// Get current role from localStorage
export const getCurrentRole = () => {
  const authRole = localStorage.getItem('authRole');
  const roleMapping = {
    'wallet_superadmin': 'SuperAdmin',
    'wallet_finance': 'Finance', 
    'wallet_ops': 'Ops',
    'wallet_support': 'Support'
  };
  return roleMapping[authRole] || null;
};

// Currency formatter
export const formatCurrency = (value) => {
  const num = Number(value);
  if (isNaN(num)) return '₹0.00';
  return `₹${num.toFixed(2)}`;
};

// Validate cart items
export const validateCartItems = (cart) => {
  let isValid = true;
  const updatedCart = cart.map(item => {
    const errors = {};
    
    // Validate MRP - required, must be >= 0 (0 is valid)
    if (item.mrp === null || item.mrp === undefined || item.mrp === '') {
      errors.mrpError = 'MRP is required';
      isValid = false;
    } else if (item.mrp < 0) {
      errors.mrpError = 'MRP must be >= 0';
      isValid = false;
    }
    
    // Validate AyushPay Price - required, must be >= 0 (0 is valid), cannot exceed MRP
    if (item.ayushpayPrice === null || item.ayushpayPrice === undefined || item.ayushpayPrice === '') {
      errors.ayushpayPriceError = 'AyushPay Price is required';
      isValid = false;
    } else if (item.ayushpayPrice < 0) {
      errors.ayushpayPriceError = 'AyushPay Price must be >= 0';
      isValid = false;
    } else if (item.mrp != null && item.mrp !== '' && !isNaN(parseFloat(item.mrp)) && item.ayushpayPrice > parseFloat(item.mrp)) {
      errors.ayushpayPriceError = 'AyushPay Price cannot exceed MRP';
      isValid = false;
    }
    
    return { ...item, ...errors };
  });
  
  return { isValid, updatedCart };
};

// Validate delivery charge
export const validateDeliveryCharge = (charge) => {
  if (charge !== null && charge !== undefined && charge < 0) {
    return 'Delivery Charge must be >= 0';
  }
  return null;
};

// Calculate cart totals
export const calculateCartTotals = (cart, deliveryCharge, handlingCharge, platformCharge) => {
  const totalMRP = cart.reduce((sum, item) => {
    if (item.outOfStock) return sum;
    const mrp = item.mrp !== null && item.mrp !== undefined ? item.mrp : 0;
    return sum + (mrp * (item.quantity || 1));
  }, 0) + 
  (deliveryCharge !== null && deliveryCharge !== undefined ? deliveryCharge : 0) +
  (handlingCharge !== null && handlingCharge !== undefined ? handlingCharge : 0) +
  (platformCharge !== null && platformCharge !== undefined ? platformCharge : 0);

  const totalAyushPay = cart.reduce((sum, item) => {
    if (item.outOfStock) return sum;
    const ayushpayPrice = item.ayushpayPrice !== null && item.ayushpayPrice !== undefined ? item.ayushpayPrice : 0;
    return sum + (ayushpayPrice * (item.quantity || 1));
  }, 0);

  return { totalMRP, totalAyushPay };
};

// Cancellation reasons
export const CANCELLATION_REASONS = [
  { value: 'all_out_of_stock', label: 'All Items Out of Stock' },
  { value: 'customer_cancelled', label: 'Customer Cancelled' },
  { value: 'payment_failed', label: 'Payment Failed' },
  { value: 'vendor_unavailable', label: 'Vendor Unavailable' },
  { value: 'other', label: 'Other' }
];

// Map cart item from API response
export const mapCartItemFromAPI = (item) => ({
  itemId: item.id,
  medicineId: item.service_item_id || item.medicine_id,
  name: item.service_item_name || item.name,
  // Pack label ("10 tablets") — resolved from the catalog by the API, so it can
  // legitimately be absent; the cart renders it only when present.
  packSize: item.pack_size || '',
  quantity: item.quantity || 1,
  mrp: item.mrp_per_unit !== undefined && item.mrp_per_unit !== null 
    ? item.mrp_per_unit 
    : (item.mrp !== undefined && item.mrp !== null ? item.mrp : null),
  ayushpayPrice: item.ayushpay_price_per_unit !== undefined && item.ayushpay_price_per_unit !== null 
    ? item.ayushpay_price_per_unit 
    : (item.ayushpay_price !== undefined && item.ayushpay_price !== null ? item.ayushpay_price : null),
  outOfStock: item.is_out_of_stock || false,
  image: item.service_item_image || item.image || null
});

// Map medicine from API response
export const mapMedicineFromAPI = (item) => ({
  id: item.id,
  service_item_id: item.service_item_id,
  name: item.service_item_name,
  pack_size: item.pack_size || '',
  price: item.partner_price || 0,
  mrp: item.partner_price || 0,
  ayushpay_price: item.partner_discount || 0,
  image: item.image_url || null,
  unit: item.unit || 'unit'
});

